import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '@fontsource/vazirmatn/400.css';
import '@fontsource/vazirmatn/500.css';
import '@fontsource/vazirmatn/600.css';
import '@fontsource/vazirmatn/700.css';
import './styles/global.css';
import './styles/product-actions.css';
import './styles/admin-generations.css';
import './styles/revision.css';
import './styles/user-panel.css';
import './styles/designer-workspace.css';

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
